import { ObjectFieldTemplateProps } from "@rjsf/utils";

function HouseSummaryTemplate(props: ObjectFieldTemplateProps, func: any) {
  return (
    <>
      <div className="cms-section">
      <div className="h3">{props.title}</div>
        <div className="section row">
          <div className="col-12">
            <div className="property-wrapper">
              {func("img", props)?.content}
            </div>
          </div>
          <div className="col-12">
            <div className="property-wrapper">
              {func("abbreviation", props)?.content}
            </div>
          </div>
          <div className="col-12">
            <div className="property-wrapper">
              {func("text", props)?.content}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HouseSummaryTemplate;
